import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChargementService {
  isLoading = signal(false);
}
